import styleFunctionSx from '../styleFunctionSx';

function sx(styles) {
  return ({
    theme
  }) => styleFunctionSx({
    sx: styles,
    theme
  });
}

export default sx;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/sx/sx.js
// module id = 891
// module chunks = 1